<div class="container flex">
  <div class="header">
    <table class="az-table">
      <thead>
        <td colspan="2">Select Zones:</td>
        <td>
          <i
            class="refresh"
            inlineSVG="/assets/icons/refresh.svg"
            (click)="vm.loadAvailabilityZonesReport()"
          ></i>
        </td>
      </thead>
      <tbody>
        <tr
          *ngFor="let az of vm.allAvailabilityZones"
          (click)="vm.onAvailabilityZoneChanged(az)"
        >
          <td>
            <input type="checkbox" [checked]="az.selected" />
          </td>
          <td [ngStyle]="{ color: az.colorHex }">{{ az.displayName }}</td>
          <td>
            <div class="status" [ngClass]="{ online: az.isOnline }">
              {{ az.renderersCount }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="body">
    <div class="flex row fill-height justify-center">
      <div class="flex column justify-center fill-width">
        <div
          class="evrideo-monitoring-chart flex row space-between fill-width"
          *ngIf="vm.selectedAvailabilityZones.length > 0"
        >
          <div class="y-label">mbit/s</div>
          <div class="chart-duration">
            <icn-dropdown
              [allowMultiple]="false"
              [(selectedValue)]="vm.selectedTimeMins"
              (selectedValueChange)="vm.getAvailabilityZonesChartUrl()"
            >
              <icn-dropdown-item
                [title]="'Hour'"
                [value]="60"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'6 Hours'"
                [value]="60 * 6"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'Day'"
                [value]="60 * 24"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'Week'"
                [value]="60 * 24 * 7"
              ></icn-dropdown-item>
            </icn-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="vm.selectedAvailabilityZones.length > 0">
      <evrideo-monitoring-chart
        [url]="vm.availabilityZonesChartUrl"
      ></evrideo-monitoring-chart>
    </div>
    <h1 *ngIf="vm.selectedAvailabilityZones.length === 0">
      No Availability Zone Selected
    </h1>
  </div>
</div>
